import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "../App.css";
import OcAboutPain from "../components/ordercream/ocaboutpain";
import OcAnythingelse from "../components/ordercream/ocanythingelse";
import OcAssociatedsymptoms from "../components/ordercream/ocassociatedsymptoms";
import OcConditionSpecificQ from "../components/ordercream/occonditionspecificq";
import OcDemographics from "../components/ordercream/ocdemographics";
import OcInjuryhistory from "../components/ordercream/ocinjuryhistory";
import OcMedicalHistory from "../components/ordercream/ocmedicalhistory";
import OcMedicineHistory from "../components/ordercream/ocmedicinehistory";
import OcPainfactors from "../components/ordercream/ocpainfactors";
import OcPainmanagementGoals from "../components/ordercream/ocpainmanagementgoals";
import "../index.css";
import "./../styles/painEntryForm.css";
import { useNavigate, useSearchParams } from "react-router-dom";

import {
  getMyLatestOrderDemoGraphics,
  handleGoBack,
  handleGoToNextStep,
  handleUpdateErrorsOfOrderCreamForm,
  handleUpdateSelectedState,
  handleUpdateShippingDetails,
  handleUpdateTransactionId,
  getOrderByTransactionIdApi,
  saveStep0Api,
  saveStep1Api,
  saveStep2Api,
} from "../redux-toolkit/slices/orderCreamSlice";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { validateOrderCreamGetStarted } from "../schemas/OrderCream";
// import ErrorList from "../components/Items/ErrorsList";

const OrderCream = () => {
  const orderCreamForm = useSelector((state: RootState) => state.orderCream);
  const userProfile = useSelector((state: RootState) => state.auth.userProfile);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const paymentId = searchParams.get("paymentId");
  const stepParam = searchParams.get("step");
  const firstName = searchParams.get("firstName");
  const lastName = searchParams.get("lastName");
  const phoneNumber = searchParams.get("phoneNumber");
  const city = searchParams.get("city");
  const state = searchParams.get("state");
  const zipCode = searchParams.get("zipCode");
  const street1 = searchParams.get("street1");
  const street2 = searchParams.get("street2");
  const email = userProfile?.email || searchParams.get("email") || "";
  const navigate = useNavigate();

  useEffect(() => {
    if (paymentId) {
      dispatch(handleUpdateTransactionId(paymentId));
      dispatch(handleUpdateSelectedState(state || ""));
      dispatch(
        handleUpdateShippingDetails({
          firstName: firstName || "",
          lastName: lastName || "",
          email,
          phoneNumber,
          address: {
            street1: street1 || "",
            street2: street2 || "",
            city: city || "",
            state: state || "",
            zipCode: zipCode || "",
          },
        })
      );

      // Fetch existing order if it exists
      const loadOrder = async () => {
        try {
          const orderData = await dispatch(
            getOrderByTransactionIdApi(paymentId)
          ).unwrap();
          if (orderData) {
            // Order exists, use its currentStep
            const stepFromOrder = orderData.currentStep || 0;
            const stepFromUrl = stepParam ? parseInt(stepParam, 10) : null;
            const finalStep =
              stepFromUrl !== null && !isNaN(stepFromUrl)
                ? stepFromUrl
                : stepFromOrder;

            // Update URL with step if not present or different
            if (!stepParam || stepParam !== finalStep.toString()) {
              const newParams = new URLSearchParams(searchParams);
              newParams.set("step", finalStep.toString());
              setSearchParams(newParams, { replace: true });
            }
          } else {
            // No order exists, check if step param exists
            if (stepParam) {
              const step = parseInt(stepParam, 10);
              if (isNaN(step) || step < 0 || step >= 10) {
                // Invalid step, set to 0
                const newParams = new URLSearchParams(searchParams);
                newParams.set("step", "0");
                setSearchParams(newParams, { replace: true });
              }
              // If valid, keep it
            } else {
              // No step param, set to 0
              const newParams = new URLSearchParams(searchParams);
              newParams.set("step", "0");
              setSearchParams(newParams, { replace: true });
            }
          }
        } catch (error) {
          console.error("Error loading order:", error);
          // If error, still set step to 0 or from URL
          if (!stepParam) {
            const newParams = new URLSearchParams(searchParams);
            newParams.set("step", "0");
            setSearchParams(newParams, { replace: true });
          }
        } finally {
          dispatch(getMyLatestOrderDemoGraphics());
          setIsLoading(false);
        }
      };

      loadOrder();
    } else {
      navigate(`/payment`);
    }
  }, [paymentId]);

  const {
    selectedState,
    currentStep: reduxCurrentStep,
    getStarted,
    isError,
    errors,
    shippingDetails,
    isLoading: reduxIsLoading,
  } = orderCreamForm;
  const dispatch = useAppDispatch();

  const components = [
    // <></>,
    // <></>,
    // <OcZipcode />,
    // <OcGetStarted />,
    // <OcPayment />,
    <OcDemographics />,
    <OcAboutPain />,
    <OcPainfactors />,
    <OcAssociatedsymptoms />,
    <OcConditionSpecificQ />,
    <OcMedicalHistory />,
    <OcInjuryhistory />,
    <OcMedicineHistory />,
    <OcPainmanagementGoals />,
    <OcAnythingelse />,
  ];

  const titles = [
    // "",
    // "Let’s see if we’re available in your area.",
    // "Great News! We Can Serve You!",
    "Tell us about yourself",
    `${shippingDetails.firstName}, let's talk about your pain profile.`,
    "Pain influencers",
    "What else do you experience?",
    `${shippingDetails.firstName}'s Pain Details`,
    `${shippingDetails.firstName}s Medical History`,
    `${shippingDetails.firstName}'s Injuries Details`,
    `${shippingDetails.firstName}'s Medication List`,
    "Tell us about your pain management goals",
    "Anything else you want to share with your provider?",
  ];

  const labels = [
    // "",
    // "",
    "We'll start with some basic information. Then we'll learn more about your pain. This information helps us pinpoint a formula for you. ",
    "Tell us where it hurts, and how it feels, when it started, and how it feels right now.",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Order Cream Now",
  ];

  // Use step from URL if available, otherwise use Redux
  const currentStep =
    stepParam && !isNaN(parseInt(stepParam, 10))
      ? parseInt(stepParam, 10)
      : reduxCurrentStep;

  // Sync Redux currentStep from URL when URL changes (but only if different)
  useEffect(() => {
    if (stepParam && !isNaN(parseInt(stepParam, 10))) {
      const urlStep = parseInt(stepParam, 10);
      if (urlStep !== reduxCurrentStep && urlStep >= 0 && urlStep < 10) {
        // Update Redux to match URL by calling handleGoBack or handleGoToNextStep
        if (urlStep < reduxCurrentStep) {
          // Going back - need to call handleGoBack multiple times
          const stepsToGoBack = reduxCurrentStep - urlStep;
          for (let i = 0; i < stepsToGoBack; i++) {
            dispatch(handleGoBack());
          }
        } else if (urlStep > reduxCurrentStep) {
          // Going forward - need to call handleGoToNextStep multiple times
          const stepsToGoForward = urlStep - reduxCurrentStep;
          for (let i = 0; i < stepsToGoForward; i++) {
            dispatch(handleGoToNextStep());
          }
        }
      }
    }
  }, [stepParam, reduxCurrentStep, dispatch]);

  const handleNext = async () => {
    if (currentStep < components.length - 1) {
      // Validate and save based on current step
      if (currentStep === 0) {
        // Step 0: Save Demographics
        try {
          await dispatch(
            saveStep0Api({
              transactionId: paymentId || "",
              demoGraphics: orderCreamForm.demoGraphics,
              shippingDetails: orderCreamForm.shippingDetails,
              selectedState: orderCreamForm.selectedState,
            })
          ).unwrap();

          // Update URL with new step
          const newParams = new URLSearchParams(searchParams);
          newParams.set("step", "1");
          setSearchParams(newParams, { replace: true });

          dispatch(handleGoToNextStep());
        } catch (error) {
          dispatch(
            handleUpdateErrorsOfOrderCreamForm({
              isError: true,
              errors: ["Failed to save step. Please try again."],
            })
          );
        }
        return;
      }

      if (currentStep === 1) {
        // Step 1: Save About Pain
        if (!selectedState) {
          return dispatch(
            handleUpdateErrorsOfOrderCreamForm({
              isError: true,
              errors: ["Please select your Zip Code"],
            })
          );
        }

        try {
          // Sanitize painProfile to remove _id fields
          const sanitizedPainProfile = {
            painRating: orderCreamForm.painProfile.painRating,
            painDuration: orderCreamForm.painProfile.painDuration,
            painDescriptions: orderCreamForm.painProfile.painDescriptions || [],
            painLocations: orderCreamForm.painProfile.painLocations || [],
          };
          await dispatch(
            saveStep1Api({
              transactionId: paymentId || "",
              painProfile: sanitizedPainProfile,
            })
          ).unwrap();

          // Update URL with new step
          const newParams = new URLSearchParams(searchParams);
          newParams.set("step", "2");
          setSearchParams(newParams, { replace: true });

          dispatch(handleGoToNextStep());
        } catch (error) {
          dispatch(
            handleUpdateErrorsOfOrderCreamForm({
              isError: true,
              errors: ["Failed to save step. Please try again."],
            })
          );
        }
        return;
      }

      if (currentStep === 2) {
        // Step 2: Save Pain Factors
        const { isError, errors } = validateOrderCreamGetStarted(getStarted);
        if (isError) {
          return dispatch(
            handleUpdateErrorsOfOrderCreamForm({ isError, errors })
          );
        }

        try {
          // Sanitize painFactors to remove _id fields
          const sanitizedPainFactors = {
            physicalActivity: orderCreamForm.painFactors.physicalActivity,
            painWorseDescriptions:
              orderCreamForm.painFactors.painWorseDescriptions || [],
          };
          await dispatch(
            saveStep2Api({
              transactionId: paymentId || "",
              painFactors: sanitizedPainFactors,
            })
          ).unwrap();

          // Update URL with new step
          const newParams = new URLSearchParams(searchParams);
          newParams.set("step", "3");
          setSearchParams(newParams, { replace: true });

          dispatch(handleGoToNextStep());
        } catch (error) {
          dispatch(
            handleUpdateErrorsOfOrderCreamForm({
              isError: true,
              errors: ["Failed to save step. Please try again."],
            })
          );
        }
        return;
      }

      // For steps 3+, just navigate (APIs will be added later)
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", (currentStep + 1).toString());
      setSearchParams(newParams, { replace: true });
      dispatch(handleGoToNextStep());
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", (currentStep - 1).toString());
      setSearchParams(newParams, { replace: true });
      dispatch(handleGoBack());
    }
  };
  if (isLoading || orderCreamForm.isDemoGraphicsLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="common-section">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center py-8">
          <div
            className="login-form-container payment-form-left-aligned rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden relative w-full"
            style={{ backgroundColor: "var(--neutral-100)" }}
          >
            <div className="header-content">
              <h3
                className={`h3 header-title ${
                  labels[currentStep] ? "with-label" : ""
                }`}
              >
                {titles[currentStep]}
              </h3>
              {labels[currentStep] && (
                <Typography className="h6 text-theme-textsecondary">
                  {labels[currentStep]}
                </Typography>
              )}
            </div>

            <div className="flex justify-start mb-6">
              <svg
                viewBox="0 0 122 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[92px] md:w-[122px]"
              >
                <path
                  opacity="0.4"
                  d="M1.46484 6.83613L4.45387 3.7103C7.74598 0.267505 13.38 0.760513 16.0241 4.72277L16.5428 5.50001C19.2423 9.54539 25.1877 9.54539 27.8873 5.5V5.5C30.5869 1.45461 36.5322 1.45461 39.2318 5.5V5.5C41.9314 9.54539 47.8768 9.54539 50.5764 5.5V5.5C53.2759 1.45461 59.2213 1.45461 61.9209 5.5V5.5C64.6205 9.54539 70.5658 9.54539 73.2654 5.5V5.5C75.965 1.45461 81.9104 1.45461 84.61 5.5V5.5C87.3096 9.54539 93.2549 9.54539 95.9545 5.5V5.5C98.6541 1.45461 104.599 1.45461 107.299 5.5V5.5C109.999 9.54539 115.944 9.54539 118.644 5.5L120.534 2.66667"
                  stroke="var(--primary-500)"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            {/* Special layout for payment step */}
            {currentStep === components.length - 1 ? (
              // Payment step gets its own layout
              <div className="w-full">{components[currentStep]}</div>
            ) : (
              // All other steps use the standard layout
              <div className="order-cream-entry">
                <div className="flex flex-col gap-5 w-full">
                  {components[currentStep]}

                  {/* Error Display */}
                  {/* {isError === true && (
                    <div className="mt-6">
                      <ErrorList errors={errors} />
                    </div>
                  )} */}

                  {/* Submit Button for steps 0 and 1 */}
                  {/* {[0, 1].includes(currentStep) && (
                    <div
                      className="flex justify-center gap-4"
                      style={{ marginTop: "40px" }}
                    >
                      {currentStep > 1 && (
                        <button
                          onClick={handleBack}
                          className="caption2 transition-colors duration-200"
                          style={{
                            color: "var(--primary-500)",
                            textDecoration: "none",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          Previous
                        </button>
                      )}
                      <button
                        onClick={handleNext}
                        disabled={currentStep === components.length - 1}
                        className="btn btn-primary btn-lg"
                      >
                        Next
                      </button>
                    </div>
                  )} */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCream;
